import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import Staff from './personal_information_management';
import DepartmentRoleManagement from './department_role_management';
import DepthDataManagement from './depth_data_management';
import PermissionList from '../permission_management/PermissionList'
import Home from './views/home'
import NoPermission from './views/nopermission'
import PermissionStatistic from './views/permission_statistic'
import PasswdSetting from './passwd_setting'
//加外匡
import Main from '../utility/Main';
import Label_language from "../language";
const label_language = Label_language.organization_structure

const MainRoute = () => {
    return (
        <Routes>
            <Route path="/">
                <Route path={''} element={<Main language={label_language} />} />
                <Route path="departmentRole" element={<DepartmentRoleManagement mode={'departmentRole'} key={'departmentRole'} />} />
                <Route path="department" element={<DepartmentRoleManagement mode={'department'} key={'department'} />} />
                <Route path="structure" element={<DepartmentRoleManagement propsFirstDepth='單位結構' propsNameDepartment={null} mode={'structure'} key={'structure'} />} />
                <Route path="role" element={<DepartmentRoleManagement mode={'role'} key={'role'} />} />
                <Route path="depth" element={<DepthDataManagementWrapper backEditPath={'structure'} />} />
                <Route path="staff" element={<Staff
                // staff_id={26}
                // show_tab_bar={false}
                // show_chart={false}
                // show_header_title={false}
                // show_tool_bar={false} 
                />} />
                <Route path="staff_role" element={<Staff
                    key={'role'}
                    departmentMode='structure'
                // staff_id={26}
                // show_tab_bar={false}
                // show_chart={false}
                // show_header_title={false}
                // show_tool_bar={false} 
                />} />
                <Route path="staff_role_department" element={<Staff
                    key={'department'}
                    departmentMode='structure'
                    departmentOnly={true}
                // staff_id={26}
                // show_tab_bar={false}
                // show_chart={false}
                // show_header_title={false}
                // show_tool_bar={false} 
                />} />
                <Route path={'permission_management'} element={<PermissionList />} />
                <Route path="home" element={<Home />} />
                <Route path="noPermission" element={<NoPermission />} />
                <Route path="permission_statistic" element={<PermissionStatistic />} />
                <Route path="passwd_setting" element={<PasswdSetting />} />
            </Route>
        </Routes>


    );
}
export default MainRoute;

const DepthDataManagementWrapper = ({
    ...props
}) => {
    const location = useLocation();

    // 以 "pathname + search" 當作 key，只要 Query String 一變，就視為不一樣的 key
    return <DepthDataManagement key={location.pathname + location.search} {...props} />;
}